import React, { useEffect } from "react";
import { ArrowForward, Login } from "@mui/icons-material";

import "./styles.scss";

const NOAR_LOGO =
  "https://noar.health/wp-content/uploads/2022/11/Grupo-2.svg";
const MULTISCENT_IMAGE =
  "https://noar.health/wp-content/uploads/2022/11/Device-MultiScent-20-Health-novo.png";

const MultiScent20Page: React.FC = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    const previousDescription = description?.content;

    document.title = "MultiScent20 | Noar Health";
    if (description) {
      description.content =
        "Conheça o MultiScent20, tecnologia de cheiro digital para avaliações olfativas conectadas à plataforma Noar Health.";
    }

    return () => {
      document.title = previousTitle;
      if (description && previousDescription !== undefined) {
        description.content = previousDescription;
      }
    };
  }, []);

  return (
    <div className="multiscent-page">

    <header className="multiscent-header">
      <a
        className="multiscent-brand"
        href="https://noar.health/"
        aria-label="Ir para o site da Noar Health"
      >
        <img src={NOAR_LOGO} alt="Noar Health" />
      </a>

      <nav className="multiscent-nav" aria-label="Navegação principal">
        <a href="https://noar.health/tecnologia/">Tecnologia</a>
        <a href="https://noar.health/nossos-produtos/">Produtos</a>
        <a className="multiscent-login" href="/auth/login">
          <Login aria-hidden="true" />
          Entrar
        </a>
      </nav>
    </header>

    <main className="multiscent-hero">
      <section className="multiscent-copy" aria-labelledby="multiscent-title">
        <p className="multiscent-eyebrow">
          <span /> Tecnologia olfativa digital
        </p>

        <h1 id="multiscent-title">
          MultiScent<span>20</span>
        </h1>
        <h2>Uma nova forma de avaliar o olfato.</h2>

        <p className="multiscent-description">
          Cheiro digital com tecnologia de ar seco, testes guiados e
          resultados integrados à plataforma Noar Health.
        </p>

        <div className="multiscent-actions">
          <a
            className="multiscent-button multiscent-button--primary"
            href="https://noar.health/contato/"
          >
            Solicitar uma proposta
            <ArrowForward aria-hidden="true" />
          </a>
          <a
            className="multiscent-button multiscent-button--secondary"
            href="https://noar.health/tecnologia/"
          >
            Conhecer a tecnologia
          </a>
        </div>

        <ul className="multiscent-features" aria-label="Principais recursos">
          <li>
            <strong>20</strong>
            <span>Cápsulas de fragrâncias</span>
          </li>
          <li>
            <strong>Bluetooth</strong>
            <span>Operação conectada</span>
          </li>
          <li>
            <strong>Web</strong>
            <span>Resultados na plataforma</span>
          </li>
        </ul>
      </section>

      <section className="multiscent-product" aria-label="MultiScent20">
        <div className="multiscent-orbit multiscent-orbit--outer" />
        <div className="multiscent-orbit multiscent-orbit--inner" />
        <div className="multiscent-product-glow" />
        <img
          className="multiscent-device"
          src={MULTISCENT_IMAGE}
          alt="Equipamento MultiScent20 da Noar Health"
        />
        <div className="multiscent-product-note">
          <span className="multiscent-product-note__icon" />
          <span>
            <small>Tecnologia</small>
            Liberação por ar seco
          </span>
        </div>
      </section>
    </main>

    <div className="multiscent-signature" aria-hidden="true">
      NOAR HEALTH · DIGITAL SCENT
    </div>
    </div>
  );
};

export default MultiScent20Page;
